<div fxLayout="row" fxLayoutAlign="start center">
    <div *ngFor="let breadcrumb of breadcrumbs" class="divider-arrow">
        <h3 [routerLink]="breadcrumb.url" routerLinkActive="router-link-active">
          {{ breadcrumb.label }}
        </h3>
    </div>
</div>